import React from 'react';
import {connect} from 'react-redux';
import '../YearToDateTableV2.scss';

import LocalBeaconTable from 'components/shared/Table/BeaconTable';
import {generateRows, renderAccountRow} from './YearToDateTableV2Utility';
import {ytdTableHeaders} from 'components/shared/Text/ColumnHeaders';

const TaxonomyTables = ({
    taxonomyData,
    ytdTaxInformation,
    displayYear,
    isRetirementAdvisoryServiceClient,
    isCWV,
    uberId,
}) => {
    return taxonomyData.map((hierarchy, i) => {
        let tableRows = [];
        if(hierarchy.type === 'RETAIL' || hierarchy.type === 'ADVISORY' || hierarchy.type === 'SMALL_BUSINESS_RETIREMENT') {
            tableRows = [
                ...tableRows,
                {...generateRows('category-row remove-border-block-end', hierarchy.name, false)}
            ];
            hierarchy.accountGroup.map(accountType => {
                tableRows = [
                    ...tableRows,
                    {...generateRows('account-type-row', accountType.name, true, accountType, ytdTaxInformation, displayYear)}
                ];
                accountType.agreements.map(agreement => {
                    // map to get ytdData for each agreement
                    const ytdTaxData = ytdTaxInformation.find(ytd => ytd.accountId === agreement.agreementKey.agreementID);
                    tableRows = [
                        ...tableRows,
                        {...renderAccountRow(agreement, ytdTaxData, displayYear, isRetirementAdvisoryServiceClient, isCWV, uberId)}
                    ];
                })
            });
        }

        return (
          <div key={i} id='ytd-taxonomy-beacon-table-v2-wrapper'>
            <LocalBeaconTable
                key={i}
                idName={'ytd-taxonomy-beacon-table-v2'}
                headers={ytdTableHeaders}
                rowsArray={tableRows}
                variant={'fixed'}
                renderStickyRows={true}
                rowsPerPage={15}
            />
          </div>
        );
    });
};

export default connect()(TaxonomyTables);
